@if (isEdit) {
  <div
    class="field"
    >
    <label class="upper">{{ displayName }}</label>
    <div class="control">
      @for (item of editValue; track item.id) {
        <div
          fxLayout="row"
          fxLayoutAlign="space-between center"
          >
          <div style="min-width: 150px">
            {{ item.name }}
          </div>
          <div>
            <button
              class="button is-small is-ghost"
              (click)="deleteItem(item)">
              <i class="icon icon-delete_trash"></i>
            </button>
          </div>
        </div>
      }
      @if (isAdvancedEdit) {
        <textarea
          class="textarea"
          [placeholder]="displayName"
          [(ngModel)]="value"
        rows="5"></textarea>
      }
    </div>
  </div>
}
